<div *ngIf="showPaymentType">
  <ng-container *ngIf="showPaymentTypePrefix">
    <yc-i18n
      key="MANAGE:textPaymentType">
    </yc-i18n>: 
  </ng-container>
  {{ paymentType | gcPaymentTypeToText }}
</div>